const getBoundingClientRect = (element: Element): Promise<DOMRect> => {
  return new Promise((resolve, reject) => {
    const observer = new IntersectionObserver(entries => {
      if (entries.length !== 1)
        reject(new Error('Unexpected number of entries'))
      const rect = entries[0].boundingClientRect
      observer.disconnect()
      resolve(rect)
    })

    observer.observe(element)
  })
}

export default getBoundingClientRect
